module.exports = __webpack_public_path__ + "img/Blekenaangepast.c1c1de93.png";